"use client";

import { SProduct } from "@/__generated__/graphql";
import { Backdrop, Box, Card, CircularProgress, Grid, Typography, useTheme } from "@mui/material";
import ProductCard from "./ProductCard";
import NotFoundComponent from "@/app/(main)/_components/NotFoundComponent";
import { useSiteSearchContext } from "@/app/(main)/_components/SITESEARCH/SiteSearchContext";
import ProductCardSkeleton from "@/app/(main)/_components/SITESEARCH/ProductCardSkeleton";
import React from "react";
import LogoLoading from "@/app/(main)/_components/LogoLoading";
import SelectedTagFilters from "@/app/(main)/_components/SelectedTagFilters";

export default function SearchProductsList() {
  const { items, isFetchingNewPageItems, isPending, selectedTags, handleRemoveTag, search, targetCategory } =
    useSiteSearchContext();
  const surface = search ? "search" : targetCategory ? "category_listing" : "search";

  return (
    <Box sx={{ position: "relative" }}>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "rgba(255,255,255,0.35)",
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: 2,
          borderRadius: 3,
        }}
        open={Boolean(isPending)}
      >
        <Card
          elevation={0}
          sx={{
            position: "fixed",
            boxShadow: `3px 6px 24px -6px #A1A1A129,-3px 0px 24px -6px #A1A1A11F`,
            py: 2,
            borderRadius: 3,
            top: "50%",
            left: "50%",
            minWidth: 120,
            minHeight: 100,
            alignItems: "center",
            flexDirection: "column",
            display: "flex",
            justifyContent: "center",
            transform: "translate(-50%,-50%)",
          }}
        >
          <LogoLoading />
        </Card>
      </Backdrop>

      <SelectedTagFilters tags={selectedTags} onRemove={handleRemoveTag} />
      <Grid container spacing={1.5} item xs={12} sx={{ mt: selectedTags.length ? 1.5 : 0 }}>
        {Boolean(items && items.length <= 0 && !isFetchingNewPageItems) && (
          <NotFoundComponent primary={"محصولی یافت نشد!"} secondary={""} image={"/errors/noProducts.svg"} />
        )}
        {items &&
          items.map((product, i) => {
            return (
              <Grid key={String(product.code) + String(product.id) + String(i)} item xs={6} md={4} sm={4} lg={3} xl={3}>
                <ProductCard product={product as SProduct} surface={surface} position={i} />
              </Grid>
            );
          })}
        {isFetchingNewPageItems &&
          Array.from({ length: 8 }).map((_, i) => {
            return (
              <Grid key={i} item xs={6} md={4} sm={4} lg={3} xl={3}>
                <ProductCardSkeleton />
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
}
